import { useEffect } from 'react';
import { services } from '../../data/services';
import { serviceCities, serviceCounties, site } from '../../data/site';
import { testimonials } from '../../data/testimonials';
import { images } from '../../data/images';
export function StructuredData() {
  useEffect(() => {
    const data = {
      '@context': 'https://schema.org',
      '@type': ['LocalBusiness', 'HealthAndBeautyBusiness'],
      '@id': `${site.website}/#business`,
      name: site.name,
      url: site.website,
      image: images.hero.src,
      telephone: site.phoneIntl,
      email: site.email,
      slogan: site.tagline.en,
      priceRange: '$$',
      availableLanguage: ['English', 'Spanish'],
      address: {
        '@type': 'PostalAddress',
        streetAddress: site.address.street,
        addressLocality: site.address.city,
        addressRegion: site.address.region,
        postalCode: site.address.postalCode,
        addressCountry: 'US'
      },
      areaServed: [...serviceCities.map(c => ({
        '@type': 'City',
        name: `${c}, VA`
      })), ...serviceCounties.map(c => ({
        '@type': 'AdministrativeArea',
        name: `${c.en}, VA`
      }))],
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '00:00',
        closes: '23:59'
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5.0',
        bestRating: '5',
        reviewCount: String(site.reviewCount)
      },
      review: testimonials.map(r => ({
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: r.name
        },
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5'
        },
        reviewBody: r.quote.en
      })),
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Home Care Services',
        itemListElement: services.map(s => ({
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: s.name.en,
            description: s.summary.en,
            areaServed: 'Northern Virginia',
            provider: {
              '@id': `${site.website}/#business`
            }
          }
        }))
      }
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'am-homecare-schema';
    script.text = JSON.stringify(data);
    document.getElementById('am-homecare-schema')?.remove();
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
  return null;
}